const CLEAN_NUMBER_REGEXP = /[^\d]/g

export function cleanNumber(number: string) {
  return number.replace(CLEAN_NUMBER_REGEXP, '')
}

/** Add zero before decimal separator if no other number exists before decimal separator */
export function appendPreDecimalZero(value: string, decimalSeparator: string) {
  return value.startsWith(decimalSeparator) ? value.replace(decimalSeparator, '0' + decimalSeparator) : value
}

export function getCleanNumber(value: string, decimalSeparator: string) {
  const outputValue = appendPreDecimalZero(value, decimalSeparator).split(decimalSeparator).map(cleanNumber).join('.')
  return outputValue
}
